import CornerBg from "@/assets/img/illustrations/corner-2.png";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { FC, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import Background from "@/components/atoms/Background";
import ErrorComponent from "@/components/atoms/ErrorComponent";
import Flex from "@/components/atoms/Flex";
import IconButton from "@/components/atoms/IconButton";
import Loader from "@/components/atoms/Loader";
import UnknownBadge from "@/components/atoms/UnknownBadge";
import { CardDetailsProps } from "@/interfaces/Card";
import Course from "@/interfaces/Course";
import { useGetCourseQuery } from "@/services/courses";
import CardHeader from "../../card-headers/CardHeader";

const CourseDetailsCard: FC<CardDetailsProps<Course>> = ({
  id,
  card,
  showDetailsButton,
  callBack,
}) => {
  const { data, isLoading, isError, error } = useGetCourseQuery(id);

  useEffect(() => {
    data && callBack?.(data);
  }, [data]);

  if (isLoading) {
    return <Loader absolute />;
  } else if (isError) {
    return <ErrorComponent error={error} absolute returnButton />;
  }

  return (
    <div
      className={classNames({
        card: card,
      })}
    >
      {card && <CardHeader title="Informations de la formation" />}
      <div
        className={classNames("bg-light", {
          "card-body": card,
        })}
      >
        <Card className="border rounded-3 bg-white dark__bg-1000 shadow-none">
          <Background
            image={CornerBg}
            className="bg-card d-none d-sm-block d-xl-none"
          />
          <Card.Body className="row g-0 flex-column flex-sm-row flex-xl-column z-index-1 align-items-center">
            <Col sm={8} md={6} lg={4} xl={12} className="ps-sm-1 ps-xl-0">
              <Flex alignItems="xl-center" direction="column">
                <p className="fw-semi-bold text-800 text-center mb-0">
                  {data?.name}
                </p>
              </Flex>
              <Flex justifyContent="center" className="gap-2">
                {showDetailsButton ? (
                  <IconButton
                    variant="primary"
                    icon={faEye}
                    iconAlign="left"
                    href={`/companies/${data!.id}`}
                    transform="shrink-3 down-1"
                    size="sm"
                    className="w-50 px-2 mt-2 text-nowrap"
                  >
                    <span className="fs--2">Détails</span>
                  </IconButton>
                ) : null}
              </Flex>
            </Col>
          </Card.Body>
        </Card>
        <Row className="border rounded-3 p-x1 mt-3 bg-white dark__bg-1000 mx-0 g-0">
          <Col md={6} xl={12} className="pe-md-4 pe-xl-0">
            <div className="mb-2">
              <Form.Label>#</Form.Label>
              <p className="mb-0 text-700 fs--1">
                {data?.id ?? <UnknownBadge />}
              </p>
            </div>
            <div className="mb-2">
              <Form.Label>Nom de la formation</Form.Label>
              <p className="mb-0 text-700 fs--1">
                {data?.name ?? <UnknownBadge />}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CourseDetailsCard;
